export default __webpack_public_path__ + "static/media/voltera_ΗΛ.7979490b.png";